import { useEffect, useMemo, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { api } from '../api.js';
import { useCart } from '../cart.jsx';
import { Doodle, Reveal, SprinkleBurst } from '../Doodles.jsx';

export default function Producto() {
  const { slug } = useParams();
  const nav = useNavigate();
  const { add } = useCart();
  const [p, setP] = useState(null);
  const [err, setErr] = useState('');
  const [sel, setSel] = useState({});       // { tipo: valor | [valores] }
  const [texto, setTexto] = useState('');
  const [cantidad, setCantidad] = useState(1);
  const [img, setImg] = useState(0);
  const [added, setAdded] = useState(false);
  const [burst, setBurst] = useState(false);
  const [jelly, setJelly] = useState(false);

  useEffect(() => {
    api.product(slug).then((d) => {
      setP(d);
      const init = {};
      (d.opciones || []).forEach((op) => { if (!op.multiple) init[op.tipo] = op.requerido ? '' : ''; else init[op.tipo] = []; });
      setSel(init);
    }).catch((e) => setErr(e.message));
  }, [slug]);

  const precio = useMemo(() => {
    if (!p) return 0;
    let total = p.precioBase;
    (p.opciones || []).forEach((op) => {
      const v = sel[op.tipo];
      const vals = Array.isArray(v) ? v : (v ? [v] : []);
      vals.forEach((name) => {
        const def = (op.valores || []).find((x) => x.nombre === name);
        if (def) total += def.deltaPrecio;
      });
    });
    return total;
  }, [p, sel]);

  if (err) return <div className="page"><p className="empty">{err}</p><Link to="/carta" className="btn btn--ghost">Volver a la carta</Link></div>;
  if (!p) return <div className="page"><p className="empty">Cargando…</p></div>;

  const setOpt = (op, value) => {
    setSel((prev) => {
      if (op.multiple) {
        const cur = new Set(prev[op.tipo] || []);
        cur.has(value) ? cur.delete(value) : cur.add(value);
        return { ...prev, [op.tipo]: [...cur] };
      }
      return { ...prev, [op.tipo]: value };
    });
  };

  const faltaRequerido = (p.opciones || []).some((op) => op.requerido && !sel[op.tipo]);

  const addToCart = () => {
    add({
      slug: p.slug, nombre: p.nombre, imagen: p.imagenes?.[0],
      opcionesElegidas: sel, textoPersonalizado: texto,
      cantidad, precioUnidad: precio
    });
    setAdded(true);
    setBurst(true);
    setJelly(true);
    setTimeout(() => setJelly(false), 420);
    setTimeout(() => setBurst(false), 750);
    setTimeout(() => setAdded(false), 2800);
  };

  return (
    <div className="page producto">
      <div className="prod-detail">
        <div className="prod-gallery">
          <div className="prod-hero" style={{ backgroundImage: `url(${p.imagenes?.[img] || p.imagenes?.[0]})` }} />
          {p.imagenes?.length > 1 && (
            <div className="thumbs">
              {p.imagenes.map((im, i) => (
                <button key={i} className={i === img ? 'thumb on' : 'thumb'} style={{ backgroundImage: `url(${im})` }} onClick={() => setImg(i)} />
              ))}
            </div>
          )}
        </div>

        <div className="prod-config">
          <p className="kicker hand">{p.categoria.replace(/-/g, ' ')}</p>
          <h1>{p.nombre}</h1>
          <p className="prod-long">{p.descripcion}</p>

          {(p.opciones || []).map((op) => (
            <div key={op.tipo} className="opt">
              <label>{op.etiqueta}{op.requerido && <span className="req"> *</span>}</label>
              <div className="opt-vals">
                {op.valores.map((v) => {
                  const active = op.multiple ? (sel[op.tipo] || []).includes(v.nombre) : sel[op.tipo] === v.nombre;
                  return (
                    <button key={v.nombre} className={active ? 'pill pill--on' : 'pill'} onClick={() => setOpt(op, v.nombre)}>
                      {v.nombre}{v.deltaPrecio > 0 && <span> +{v.deltaPrecio}€</span>}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}

          {p.permitePersonalizarTexto && (
            <div className="opt">
              <label>Tu texto (máx. {p.maxCaracteresTexto} caracteres)</label>
              <input type="text" maxLength={p.maxCaracteresTexto} value={texto}
                onChange={(e) => setTexto(e.target.value)} placeholder="Ej: ¡Feliz cumpleaños, Laura!" />
            </div>
          )}

          {p.alergenos?.length > 0 && (
            <p className="alergenos">Alérgenos: {p.alergenos.join(', ')}.</p>
          )}

          <div className="buy">
            <div className="qty">
              <button onClick={() => setCantidad((c) => Math.max(1, c - 1))}>−</button>
              <span>{cantidad}</span>
              <button onClick={() => setCantidad((c) => c + 1)}>+</button>
            </div>
            <div className="buy-price">{(precio * cantidad).toFixed(2)} €</div>
          </div>

          <div className="add-wrap">
            <button className={`btn btn--primary btn--block${jelly ? ' jelly' : ''}`} disabled={faltaRequerido} onClick={addToCart}>
              {faltaRequerido ? 'Elige las opciones marcadas con *' : 'Añadir al pedido'}
            </button>
            <SprinkleBurst show={burst} />
          </div>
          {added && (
            <div className="added">
              <Doodle name="sparkle" size={22} color="var(--mint-d)" /> ¡En el horno!{' '}
              <button className="linklike" onClick={() => nav('/pedido')}>Ir a mi pedido →</button>
            </div>
          )}
          <p className="note">
            <Doodle name="heart" size={18} color="var(--rose)" />
            Sin pago online: envías la solicitud y te confirmamos disponibilidad por WhatsApp.
          </p>
        </div>
      </div>
    </div>
  );
}
